import { Preloader } from '@cian/preloader-component';
import { mergeStyles, plural } from '@cian/utils';
import * as React from 'react';

import { EMetaStatus, IMetaState, IGeocodeState, EGeocodeStatus } from '../../types/filters';
import * as tracking from './tracking';
import * as styles from './FiltersSearchButton.css';

export interface IFiltersSearchButtonProps {
  meta: IMetaState;
  geocode: IGeocodeState;
  getMeta(): void;
}

export interface IFiltersSearchButtonState {
  isClicked: boolean;
  isLoading: boolean;
}

const LOADER_TIMEOUT = 300;

export class FiltersSearchButton extends React.Component<IFiltersSearchButtonProps, IFiltersSearchButtonState> {
  private loadingTimeout: number;

  public state: IFiltersSearchButtonState = {
    isClicked: false,
    isLoading: false,
  };

  public componentDidUpdate(prevProps: IFiltersSearchButtonProps) {
    if (this.state.isClicked) {
      if ([EGeocodeStatus.Initial, EGeocodeStatus.Succeed].includes(this.props.geocode.status)
        && prevProps.meta.status !== this.props.meta.status && this.props.meta.status !== EMetaStatus.Loading
      ) {
        if (!this.state.isLoading) {
          window.clearTimeout(this.loadingTimeout);
        }

        switch (this.props.meta.status) {
          case EMetaStatus.Succeed:
            window.location.href = this.props.meta.url;
            tracking.trackSearchButtonClick(this.props.meta.url);
            break;

          case EMetaStatus.Failed:
            this.setState({
              isClicked: false,
              isLoading: false,
            });
            alert('Не удалось получить информацию по вашему запросу. Попробуйте ещё раз.');
            break;
        }
      }

      if (prevProps.geocode.status !== this.props.geocode.status
        && this.props.geocode.status === EGeocodeStatus.Failed
      ) {
        this.setState({
          isClicked: false,
          isLoading: false,
        });
      }
    }
  }

  public render() {
    const { meta: { url: resultsUrl, count } } = this.props;
    const { isLoading } = this.state;

    return (
      <span className={styles['container']}>
        <a
          {...mergeStyles(
            styles['button'],
            isLoading && styles['button--loading'],
          )}
          href={resultsUrl}
          title={`Доступно ${count} ${plural(count, ['предложение', 'предложения', 'предложений'])}`}
          data-mark="FiltersSearchButton"
          onClick={this.handleSearchButtonClick}
        >
          Найти
          {isLoading && <span className={styles['preloader']}>
            <Preloader
              size={18}
              stopColorForOffset0="#fff"
              stopColorForOffset1="#fff"
            />
          </span>}
        </a>
      </span>
    );
  }

  private handleSearchButtonClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { meta: { status: metaStatus }, geocode: { status: geocodeStatus } } = this.props;

    if (geocodeStatus === EGeocodeStatus.Loading || metaStatus !== EMetaStatus.Succeed) {
      event.preventDefault();

      this.setState({
        isClicked: true,
      }, () => this.loadingTimeout = window.setTimeout(() => this.setState({ isLoading: true }), LOADER_TIMEOUT));
    } else {
      tracking.trackSearchButtonClick(this.props.meta.url);
    }

    if ([EGeocodeStatus.Initial, EGeocodeStatus.Succeed].includes(geocodeStatus)
      && metaStatus === EMetaStatus.Failed
    ) {
      this.props.getMeta();
    }
  }
}
